// Widget Cloudflare Turnstile (TurnstileInput) vykreslí skript Cloudflare sám jen při načtení
// stránky. Když se formulář překreslí AJAXem (chyba validace, registrace), je kontejner nový
// a prázdný - bez ručního vykreslení by nešlo odeslat znovu.

// Widget má appearance interaction-only: dokud Cloudflare nechce interakci, má nulovou výšku
// a okraj obalu (.mb-3 z rendereru formuláře) by po něm nechal prázdnou mezeru nad tlačítkem.
const hideMargin = () => {
    document.querySelectorAll('.cf-turnstile:not([data-shown])').forEach((container) => {
        container.parentElement?.classList.replace('mb-3', 'turnstile-idle');
    });
};

window.wisartTurnstileShow = () => {
    document.querySelectorAll('.cf-turnstile').forEach((container) => {
        container.dataset.shown = '1';
        container.parentElement?.classList.replace('turnstile-idle', 'mb-3');
    });
};

const renderEmpty = () => {
    hideMargin();
    if (!window.turnstile) {
        return;
    }

    document.querySelectorAll('.cf-turnstile').forEach((container) => {
        if (container.childElementCount === 0) {
            window.turnstile.render(container);
        }
    });
};

let scheduled = false;
const init = () => {
    if (!document.querySelector('.cf-turnstile')) {
        return;
    }
    hideMargin();

    new MutationObserver(() => {
        if (scheduled) {
            return;
        }
        scheduled = true;
        requestAnimationFrame(() => {
            scheduled = false;
            renderEmpty();
        });
    }).observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
